import { render } from "./Loading.vue?vue&type=template&id=e7522aa8&ts=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.edison/edisoncd/scenarios/edison-cd-task-deploy-lite-branch/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__